import React, { createContext, useState, useEffect, useContext } from 'react';
import { getLang, updateTitle } from '../utils/translations';

// Create the language context
const LanguageContext = createContext();

// Hook to use the language context
export const useLanguage = () => useContext(LanguageContext);

// Provider component
export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(getLang());

  // Update the document title when language changes
  useEffect(() => {
    updateTitle();
  }, [language]);

  // Function to change the language
  const changeLanguage = (newLang) => {
    if (['en', 'fr', 'es'].includes(newLang)) {
      setLanguage(newLang);
      // Redirect to appropriate language URL
      const currentPath = window.location.pathname;
      if (currentPath === '/' || currentPath.match(/^\/(en|fr|es)\/?$/)) {
        window.history.pushState({}, '', `/${newLang}`);
      } else {
        // Handle other pages
        const pathWithoutLang = currentPath.replace(/^\/(en|fr|es)/, '');
        window.history.pushState({}, '', newLang === 'en' ? pathWithoutLang : `/${newLang}${pathWithoutLang}`);
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 